import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { statisticsActions } from './actions';

const typesStat = [
  { v: "queue", t: "Заявки" },
  { v: "child", t: "Діти у садочках" },
  { v: "groups", t: "Групи поточні" },
  { v: "groups_arch", t: "Групи архівні" },
  { v: "invites", t: "Запрошення" },
  { v: "attends", t: "Відвідування" },
  { v: "bfn", t: "БФН" },
  { v: "benefits", t: "Пільги" },
  { v: "personal", t: "Працівники" },
  { v: "queue_kg", t: "Черга по садочкам" }
];

const Statistica = (props) => {
  const currentDate = new Date();
  const currentStudyYear = currentDate.getMonth() < 5 ? currentDate.getFullYear() - 1 : currentDate.getFullYear();

  const [studyYear, setStudyYear] = useState(currentStudyYear);
  const [thisStudyYear] = useState(currentStudyYear);
  const [kyivReg, setKyivReg] = useState('all');
  const [kyivMr, setKyivMr] = useState('all');
  const [stateQueueLengthDistr, setStateQueueLengthDistr] = useState({});
  const [stateQueueLengthAll, setStateQueueLengthAll] = useState({});
  const [showComponent, setShowComponent] = useState(() => <div></div>);
  const [moved, setMoved] = useState('');
  const [benefitsAll, setBenefitsAll] = useState([]);
  const [benCur, setBenCur] = useState('wo');
  const [selectedMenu, setSelectedMenu] = useState('queue');
  const [invSts, setInvSts] = useState('all');
  const [inKg, setInKg] = useState('all');
  const [reqCrt, setReqCrt] = useState('all');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Определяем видимость компонентов на основе выбранного меню
  const menuVisibility = {
    shQueue: selectedMenu === 'queue',
    shChild: selectedMenu === 'child',
    shGroups: selectedMenu === 'groups',
    shGrArchive: selectedMenu === 'groups_arch',
    shInvites: selectedMenu === 'invites',
    shGroupsAttends: selectedMenu === 'attends',
    shBFN: selectedMenu === 'bfn',
    shBenefits: selectedMenu === 'benefits',
    shPersonal: selectedMenu === 'personal',
    shQueueKg: selectedMenu === 'queue_kg'
  };

  // Загрузка пільг при монтировании компонента
  useEffect(() => {
    getBenefits();
  }, []);

  const getBenefits = useCallback(async () => {
    try {
      const response = await statisticsActions.getBenefits();
      if (response.data?.length > 0) {
        setBenefitsAll(response.data);
      }
    } catch (err) {
      setError(`Помилка при завантаженні пільг: ${err}`);
    }
  }, []);

  const getInfo = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const params = [];

      if (kyivReg !== 'all') {
        params.push('kyiv_reg=true');
      }

      if (kyivMr !== 'all') {
        params.push('kyiv_mr_parent=true');
      }

      switch (benCur) {
        case 'all':
          params.push('benefits=all');
          break;
        case 'wo':
          break;
        default:
          params.push(`benefits=${benCur}`);
          break;
      }

      if (invSts !== 'all') {
        params.push(`reserv=${invSts}`);
      }

      if (inKg !== 'all') {
        params.push(`in_kg=${inKg}`);
      }

      if (reqCrt !== 'all') {
        params.push(`req_crt=${reqCrt}`);
      }

      switch (moved) {
        case 'with_move':
          params.push('with_move=true');
          break;
        case 'without_move':
          params.push('without_move=true');
          break;
      }

      await getQueueDistrict(params.join('&'));
    } catch (err) {
      setError(`Помилка при отриманні даних: ${err}`);
    } finally {
      setLoading(false);
    }
  }, [studyYear, kyivReg, kyivMr, benCur, invSts, inKg, reqCrt, moved]);

  const getQueueDistrict = useCallback(async (params = '') => {
    try {
      const response = await statisticsActions.getQueueDistrict(studyYear, params);
      
      if (response.data?.cursor?.length > 0) {
        const queueLengthDistr = {};

        response.data.cursor.forEach(element => {
          if (!queueLengthDistr.hasOwnProperty(element._id.dist)) {
            queueLengthDistr[element._id.dist] = {};
          }
          queueLengthDistr[element._id.dist][parseInt(element._id.age)] = element.count;
        });

        // Заполняем отсутствующие возрасты нулями
        Object.keys(queueLengthDistr).forEach(element => {
          for (let i = 1971; i < 1978; i++) {
            if (!queueLengthDistr[element].hasOwnProperty(i)) {
              queueLengthDistr[element][i] = 0;
            }
          }
        });

        setStateQueueLengthDistr(queueLengthDistr);
        await getQueueAll(params);
      } else {
        setShowComponent(() => <div className="alert alert-info text-center">Немає даних для відображення</div>);
      }
    } catch (err) {
      setError(`Помилка при отриманні статистики по районам: ${err}`);
    }
  }, [studyYear]);

  const getQueueAll = useCallback(async (params = '') => {
    try {
      const response = await statisticsActions.getQueueAll(studyYear, params);
      
      if (response.data?.cursor?.length > 0) {
        const queueLengthAll = {};

        response.data.cursor.forEach(element => {
          queueLengthAll[element._id] = element.count;
        });

        // Заполняем отсутствующие возрасты нулями
        for (let i = 1971; i < 1978; i++) {
          if (!queueLengthAll.hasOwnProperty(i)) {
            queueLengthAll[i] = 0;
          }
        }

        setStateQueueLengthAll(queueLengthAll);
        setShowComponent(() => tableInfo());
      }
    } catch (err) {
      setError(`Помилка при отриманні загальної статистики: ${err}`);
    }
  }, [studyYear]);

  const tableInfo = useCallback(() => {
    const tableDistr = Object.keys(stateQueueLengthDistr).map((item, i) => (
      <tr key={i} className={i % 2 === 0 ? 'table-light' : ''}>
        <td className="fw-bold">{item}</td>
        <td>{stateQueueLengthDistr[item]?.[1971] || '0'}</td>
        <td>{stateQueueLengthDistr[item]?.[1972] || '0'}</td>
        <td>{stateQueueLengthDistr[item]?.[1973] || '0'}</td>
        <td>{stateQueueLengthDistr[item]?.[1974] || '0'}</td>
        <td>{stateQueueLengthDistr[item]?.[1975] || '0'}</td>
        <td>{stateQueueLengthDistr[item]?.[1976] || '0'}</td>
        <td>{stateQueueLengthDistr[item]?.[1977] || '0'}</td>
        <td className="fw-semibold">
          {(stateQueueLengthDistr[item]?.[1971] || 0) +
           (stateQueueLengthDistr[item]?.[1972] || 0) +
           (stateQueueLengthDistr[item]?.[1973] || 0) +
           (stateQueueLengthDistr[item]?.[1974] || 0) +
           (stateQueueLengthDistr[item]?.[1975] || 0) +
           (stateQueueLengthDistr[item]?.[1976] || 0) +
           (stateQueueLengthDistr[item]?.[1977] || 0)}
        </td>
        <td className="fw-semibold">
          {(stateQueueLengthDistr[item]?.[1973] || 0) +
           (stateQueueLengthDistr[item]?.[1974] || 0) +
           (stateQueueLengthDistr[item]?.[1975] || 0)}
        </td>
      </tr>
    ));

    const tableAll = (
      <tr className="table-dark fw-bold">
        <td>Всього:</td>
        <td>{stateQueueLengthAll[1971] > 0 ? stateQueueLengthAll[1971] : 0}</td>
        <td>{stateQueueLengthAll[1972] > 0 ? stateQueueLengthAll[1972] : 0}</td>
        <td>{stateQueueLengthAll[1973] > 0 ? stateQueueLengthAll[1973] : 0}</td>
        <td>{stateQueueLengthAll[1974] > 0 ? stateQueueLengthAll[1974] : 0}</td>
        <td>{stateQueueLengthAll[1975] > 0 ? stateQueueLengthAll[1975] : 0}</td>
        <td>{stateQueueLengthAll[1976] > 0 ? stateQueueLengthAll[1976] : 0}</td>
        <td>{stateQueueLengthAll[1977] > 0 ? stateQueueLengthAll[1977] : 0}</td>
        <td>
          {(stateQueueLengthAll[1971] || 0) +
           (stateQueueLengthAll[1972] || 0) +
           (stateQueueLengthAll[1973] || 0) +
           (stateQueueLengthAll[1974] || 0) +
           (stateQueueLengthAll[1975] || 0) +
           (stateQueueLengthAll[1976] || 0) +
           (stateQueueLengthAll[1977] || 0)}
        </td>
        <td>
          {(stateQueueLengthAll[1973] || 0) +
           (stateQueueLengthAll[1974] || 0) +
           (stateQueueLengthAll[1975] || 0)}
        </td>
      </tr>
    );

    return (
      <div>
        <div className="col-md-12">
          <p className="h4 text-center mb-4">
            Черга на {studyYear}/{parseInt(studyYear) + 1} навчальний рік станом на {()=>{
                const [yy,mm,dd] = (new Date().toISOString()).split("-");
                return `${dd}.${mm}.${yy}`
                }}
          </p>
        </div>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-hover">
            <thead className="table-primary">
              <tr>
                <th scope="col">Район</th>
                <th scope="col">1-2 роки</th>
                <th scope="col">2-3 роки</th>
                <th scope="col">3-4 роки</th>
                <th scope="col">4-5 роки</th>
                <th scope="col">5-6 років</th>
                <th scope="col">6-7 років</th>
                <th scope="col">7-8 років</th>
                <th scope="col">Разом</th>
                <th scope="col">Разом 3-6</th>
              </tr>
            </thead>
            <tbody>
              {tableDistr}
              {tableAll}
            </tbody>
          </table>
        </div>

        <div className="col-md-12 mt-4">
          <div id="chart_div"></div>
        </div>
      </div>
    );
  }, [stateQueueLengthDistr, stateQueueLengthAll, studyYear]);

  const handleMenuChange = useCallback((e) => {
    setSelectedMenu(e.target.value);
    setShowComponent(() => <div></div>);
  }, []);

  const StatQueue = () => (
    <div className="card shadow-sm">
      <div className="card-body">
        <div className="row g-3">
          <div className="col-md-6 col-lg-2">
            <label htmlFor="studyYear" className="form-label">Навчальний рік:</label>
            <select 
              id="studyYear"
              className="form-select" 
              value={studyYear} 
              onChange={(e) => setStudyYear(e.target.value)}
            >
              <option value={thisStudyYear}>{thisStudyYear}/{thisStudyYear + 1}</option>
              <option value={thisStudyYear + 1}>{thisStudyYear + 1}/{thisStudyYear + 2}</option>
            </select>
          </div>

          <div className="col-md-6 col-lg-2">
            <label htmlFor="kyivReg" className="form-label">Реєстрація в Києві</label>
            <select 
              id="kyivReg"
              className="form-select" 
              value={kyivReg} 
              onChange={(e) => setKyivReg(e.target.value)}
            >
              <option value='all'>Всі заявки</option>
              <option value='kyiv_reg'>З підтвердженою реєстрацією</option>
            </select>
          </div>

          <div className="col-md-6 col-lg-2">
            <label htmlFor="kyivMr" className="form-label">Муніципальна к-ка</label>
            <select 
              id="kyivMr"
              className="form-select" 
              value={kyivMr} 
              onChange={(e) => setKyivMr(e.target.value)}
            >
              <option value='all'>Всі заявки</option>
              <option value='kyiv_mr_parent'>З наявними картками</option>
            </select>
          </div>

          <div className="col-md-6 col-lg-2">
            <label htmlFor="moved" className="form-label">Переведення</label>
            <select 
              id="moved"
              className="form-select" 
              value={moved} 
              onChange={(e) => setMoved(e.target.value)}
            >
              <option value=''>Всі заявки</option>
              <option value='with_move'>Тільки за переведенням</option>
              <option value='without_move'>Без заявок з переведенням</option>
            </select>
          </div>

          <div className="col-md-6 col-lg-4">
            <label htmlFor="benCur" className="form-label">Пільга</label>
            <select 
              id="benCur"
              className="form-select" 
              value={benCur} 
              onChange={(e) => setBenCur(e.target.value)}
            >
              <option value="wo">Всі заявки</option>
              <option value="all">Всі пільги</option>
              {benefitsAll.map((element) => (
                <option key={element._id} value={element._id}>{element.name}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="row g-3 mt-2">
          <div className="col-md-6 col-lg-4">
            <label htmlFor="reqCrt" className="form-label">Створені</label>
            <select 
              id="reqCrt"
              className="form-select" 
              value={reqCrt} 
              onChange={(e) => setReqCrt(e.target.value)}
            >
              <option value="inDay">Сьогодні</option>
              <option value="inDayPre">Вчора</option>
              <option value="inWeek">За тиждень</option>
              <option value="inWeekPre">Минулого тижня</option>
              <option value="inMonth">В цьому місяці</option>
              <option value="inMonthPre">В попередньому місяці</option>
              <option value="inQuart">В цьому кварталі</option>
              <option value="inQuartPre">В попередньому кварталі</option>
              <option value="inYear">З початку року</option>
              <option value="all">Всі заявки</option>
            </select>
          </div>

          <div className="col-md-6 col-lg-4">
            <label htmlFor="invSts" className="form-label">Запрошення(діючи)</label>
            <select 
              id="invSts"
              className="form-select" 
              value={invSts} 
              onChange={(e) => setInvSts(e.target.value)}
            >
              <option value="inDay">Сьогодні</option>
              <option value="inDayPre">Вчора</option>
              <option value="inWeek">За тиждень</option>
              <option value="inWeekPre">Минулого тижня</option>
              <option value="inMonth">В цьому місяці</option>
              <option value="inMonthPre">В попередньому місяці</option>
              <option value="wo">Без запрошень</option>
              <option value="all">Всі заявки</option>
            </select>
          </div>

          <div className="col-md-6 col-lg-4">
            <label htmlFor="inKg" className="form-label">Оформлені до садочка</label>
            <select 
              id="inKg"
              className="form-select" 
              value={inKg} 
              onChange={(e) => setInKg(e.target.value)}
            >
              <option value="inDay">Сьогодні</option>
              <option value="inDayPre">Вчора</option>
              <option value="inWeek">За тиждень</option>
              <option value="inWeekPre">Минулого тижня</option>
              <option value="inMonth">В цьому місяці</option>
              <option value="inMonthPre">В попередньому місяці</option>
              <option value="inQuart">В цьому кварталі</option>
              <option value="inQuartPre">В попередньому кварталі</option>
              <option value="inYear">З початку року</option>
              <option value="all">Всі заявки</option>
            </select>
          </div>
        </div>

        <div className='row mt-4'>
          <div className="col-md-12">
            <button 
              className="btn btn-primary" 
              onClick={getInfo} 
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Завантаження...
                </>
              ) : 'Показати'}
            </button>
          </div>
        </div>

        <div className="mt-4">&nbsp;</div>

        {error && (
          <div className="alert alert-danger mt-3" role="alert">
            {error}
          </div>
        )}

        <div className="mt-4">
          {showComponent}
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <div className="container-fluid">
        <div className="container">
          {false && (
            <div className="row mb-4">
              <div className="col-md-6 col-lg-3">
                <label htmlFor="menuSelect" className="form-label">Напрямок:</label>
                <select 
                  id="menuSelect"
                  className="form-select" 
                  value={selectedMenu} 
                  onChange={handleMenuChange}
                >
                  {typesStat.map(type => (
                    <option key={type.v} value={type.v}>{type.t}</option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {menuVisibility.shQueue && (
            <div className="col-md-12">
              <h2 className="visually-hidden">Статистика черги</h2>
              <StatQueue />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Statistica;